<template>
  <v-card>
    <v-overlay
        v-model="showPhotoOverlay"
        scroll-strategy="block"
        :close-on-content-click="$vuetify.display.mdAndDown"
        location-strategy="connected"
        class="align-center justify-center"
    >
      <v-virtual-scroll
          class="h-screen"
          :items="photos"
      >
        <template v-slot:default="{ item }">
          <v-img
              :src="item"
              :eager="true"
              :min-height="$vuetify.display.mdAndUp ? 450 : 250"
              :min-width="$vuetify.display.mdAndUp ? 900 : 400"
          />
        </template>
      </v-virtual-scroll>
    </v-overlay>
    <v-card-item>
      <v-row>
        <v-col
            v-if="$vuetify.display.mdAndUp"
            cols="6"
        >
          <carousel
              id="gallery"
              :items-to-show="1"
              :wrap-around="false"
              v-model="currentSlide"
          >
            <slide
                v-for="item in photos"
                :key="item"
            >
              <v-img
                  :max-height="$vuetify.display.lgAndUp ? 450 : 400"
                  :src="item"
                  :eager="true"
                  :cover="true"
                  class="mb-1"
                  @click="showPhotoOverlay = !showPhotoOverlay"
              />
            </slide>
          </carousel>
          <carousel
              id="thumbnails"
              :items-to-show="4"
              :wrap-around="true"
              v-model="currentSlide"
              ref="carousel"
          >
            <slide
                v-for="(item, index) in photos"
                :key="item"
            >
              <v-img
                  :src="item"
                  :eager="true"
                  :cover="true"
                  class="mx-1"
                  @click="slideTo(index)"
              />
            </slide>
          </carousel>
        </v-col>
        <v-col
            cols="12"
            md="6"
        >
          <v-row>
            <v-col class="pb-0">
              <p class="text-h5 text-no-wrap">{{ title }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col
                v-if="$vuetify.display.smAndDown"
                cols="12"
            >
              <carousel
                  id="gallery"
                  :items-to-show="1"
                  :wrap-around="false"
                  v-model="currentSlide"
              >
                <slide
                    v-for="item in photos"
                    :key="item"
                >
                  <v-img
                      :max-height="$vuetify.display.lgAndUp ? 450 : 400"
                      :src="item"
                      :eager="true"
                      :cover="true"
                      class="mb-1"
                      @click="showPhotoOverlay = !showPhotoOverlay"
                  />
                </slide>
              </carousel>
              <carousel
                  id="thumbnails"
                  :items-to-show="4"
                  :wrap-around="true"
                  v-model="currentSlide"
                  ref="carousel"
              >
                <slide
                    v-for="(item, index) in photos"
                    :key="item"
                >
                  <v-img
                      :src="item"
                      :eager="true"
                      :cover="true"
                      class="mx-1"
                      @click="slideTo(index)"
                  />
                </slide>
              </carousel>
            </v-col>
          </v-row>
          <v-row>
            <v-divider v-if="$vuetify.display.mdAndUp"/>
          </v-row>
          <v-row>
            <v-col>
              <v-row>
                <v-col>
                  <p class="text-h5 text-no-wrap">{{ managerFullName ? 'Your manager' : 'Manager isn\'t assigned' }}</p>
                </v-col>
              </v-row>
              <v-row
                  v-if="managerFullName"
                  class="mt-0"
              >
                <v-col
                    cols="2"
                    md="1"
                    class="pr-0"
                >
                  <v-icon
                      size="x-large"
                      icon="mdi-account-circle"
                  />
                </v-col>
                <v-col class="pl-0 pl-md-2 pl-lg-0">
                  <p class="text-h6">{{ managerFullName }}</p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-divider/>
          </v-row>
          <v-row>
            <v-col
                cols="12"
                md="6"
            >
              <p class="text-h6">Specification</p>
              <p class="font-weight-medium">Year: <span class="font-weight-regular">{{ year }}</span>
              </p>
              <p class="font-weight-medium">Engine: <span class="font-weight-regular">{{ engine }}cc</span></p>
              <p class="font-weight-medium">Fuel: <span class="font-weight-regular">{{ fuel }}</span>
              </p>
              <p class="font-weight-medium">Transmission: <span
                  class="font-weight-regular">{{ transmission }}</span></p>
              <p class="font-weight-medium">Color: <span class="font-weight-regular">{{ color }}</span></p>
              <p class="font-weight-medium">Mileage: <span
                  class="font-weight-regular">{{ mileage }} km</span></p>
              <p class="font-weight-medium">Specification: <span
                  class="font-weight-regular">{{ specification }}</span>
              </p>
            </v-col>
            <v-col
                cols="12"
                md="1"
            >
              <v-divider
                  class="fill-height"
                  :vertical="$vuetify.display.mdAndUp"
              />
            </v-col>
            <v-col
                cols="12"
                md="5"
            >
              <p class="text-h6">Calculation</p>
              <p class="font-weight-medium">Status: <span class="font-weight-regular">{{ status }}</span></p>
              <p class="font-weight-medium">Price(exw.): <span class="font-weight-regular">{{ numbers.formatMoney(price, 'USD') }}</span></p>
              <p
                  v-if="deliveryPrice !== null"
                  class="font-weight-medium"
              >
                Delivery price: <span class="font-weight-regular">{{ numbers.formatMoney(deliveryPrice, 'USD') }} $</span>
              </p>
              <p
                  v-if="paperworkPrice !== null"
                  class="font-weight-medium"
              >
                Paperwork price: <span class="font-weight-regular">{{ numbers.formatMoney(paperworkPrice, 'USD') }} $</span>
              </p>
              <p
                  v-if="totalPrice !== null"
                  class="font-weight-medium"
              >
                Total price: <span class="font-weight-regular">{{ numbers.formatMoney(totalPrice, 'USD') }}</span>
              </p>
              <v-btn
                  v-if="cancelButtonVisible"
                  :loading="isRequestSent"
                  :disabled="isRequestSent"
                  class="mt-3"
                  color="error"
                  @click="initiateCancel"
              >
                Cancel request
              </v-btn>
              <p
                  v-if="!cancelButtonVisible"
                  class="text-caption"
              >
                This request entered finished state. No any further
                actions allowed.
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-divider/>
      </v-row>
      <v-row>
        <v-col>
          <v-expansion-panels v-model="expandStates">
            <v-expansion-panel
                elevation="0"
            >
              <v-expansion-panel-title class="px-2">
                <p class="text-h6">Specification details</p>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <car-specification-details :equipment-groups="equipmentGroups"/>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row>
        <v-divider/>
      </v-row>
      <v-row class="px-2">
        <v-col>
          <p class="text-h6">Description</p>
          <p class="font-weight-regular">
            {{ description }}
          </p>
        </v-col>
      </v-row>
    </v-card-item>
  </v-card>
</template>

<script>

import 'vue3-carousel/dist/carousel.css'
import {Carousel, Slide} from 'vue3-carousel'
import CarSpecificationDetails from "@/components/Car/CarSpecificationDetails.vue";
import {numbers} from "@/common/numbers";

export default {
  name: "CarRequestCard",
  computed: {
    numbers() {
      return numbers
    }
  },
  components: {CarSpecificationDetails, Carousel, Slide},
  props: {
    title: String,
    photos: Array,

    managerFullName: String,

    year: String,
    engine: String,
    fuel: String,
    transmission: String,
    color: String,
    mileage: String,
    specification: String,

    status: String,
    price: Number,
    deliveryPrice: Number,
    paperworkPrice: Number,
    totalPrice: Number,
    cancelButtonVisible: Boolean,
    cancelCallback: Function,

    equipmentGroups: Object,

    description: String,
  },
  data() {
    return {
      currentSlide: 0,
      showPhotoOverlay: false,
      expandStates: [0],
      isRequestSent: false,
    }
  },
  methods: {
    async initiateCancel() {
      this.isRequestSent = true
      await this.cancelCallback()
      this.isRequestSent = true
    },
    slideTo(index) {
      this.currentSlide = index
    },
  },
}
</script>

<style scoped>

</style>